// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2WjjD","title":"index_title_JWDe5","description":"index_description_LiBSS","action":"index_action_1BhNL"};